import React from 'react';
import { siteContent } from '../data/mock';

export const HumanTrust = () => {
  const { humanTrust } = siteContent;

  return (
    <section className="bg-stone-50 border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="flex flex-col sm:flex-row gap-6 items-start max-w-2xl">
          <img
            src={humanTrust.headshot}
            alt={humanTrust.name}
            className="w-16 h-16 rounded-full object-cover flex-shrink-0 bg-stone-100"
          />
          <div>
            <p className="text-stone-800 font-medium">
              {humanTrust.intro}
            </p>
            <p className="mt-2 text-stone-600">
              {humanTrust.bio}
            </p>
            <p className="mt-3 text-sm text-stone-500 italic">
              {humanTrust.constraint}
            </p>
            <p className="mt-3 text-sm text-stone-500">
              <a 
                href={humanTrust.exampleSite.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-stone-700 underline"
              >
                {humanTrust.exampleSite.text}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
